<template>
  <span class="vs-slilder-tp">

    <vueSlider
      class="vs-slilder__input-tp"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      :height="height"
      tooltip="hover"
      :lazy="true"
      :value="renderValue"
      :dot-size="minimized ? 0 : 16"
      :bg-style="{
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
        borderRadius: 0,
        cursor: 'pointer',
      }"
      :process-style="{
        backgroundColor: '#e81a65',
        borderRadius: 0,
      }"

      @callback="handleValue"
      @drag-start="($event) => $emit('dragstart', $event)"
      @drag-end="($event) => $emit('dragend', $event)"
    >
      <template
        v-slot:tooltip="{ value: scopedValue }"
      >
        <slot
          name="floater"
          :value="scopedValue"
        />
      </template>
    </vueSlider>
  </span>
</template>

<script>
import debounce from 'lodash/debounce';
import vueSlider from 'vue-slider-component';

export default {
  components: {
    vueSlider,
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 8,
    },
    step: {
      type: [String, Number],
      default: 'any',
    },
    wide: {
      type: Boolean,
      default: false,
    },
    minimized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      renderValue: this.value,
    };
  },

  computed: {
    percentage() {
      return (this.value / this.max) * 100;
    },
    isSlidable() {
      return !(this.min === this.max);
    },
  },

  watch: {
    value(newValue, oldValue) {
      this.updateDebouncer(newValue);
    },
  },

  created() {
    this.updateDebouncer = debounce(this.updateRenderValue.bind(this), 100);
  },

  methods: {
    updateRenderValue(newValue) {
      this.renderValue = newValue;
    },

    handleValue(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.vs-slilder-tp {
  .vs-slilder__input-tp {
    padding: 0 !important;
    z-index: 1;
  }
}
</style>
